module.exports = __webpack_public_path__ + "static/media/managementTeam.245733a7.png";